import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject, Observable, map, take } from "rxjs";

export class FeedbacksService {
  private classroomId: string | undefined;

  constructor(private _stats = new StatsRest()) {
    this.classroomId = localStorage.getItem("objClassroomId") ?? undefined;
  }
  feedbacks$ = new BehaviorSubject([]);
  feedbacks = this.feedbacks$.asObservable();

  getFeedbacksByObjectiveStats(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): void {
    this._stats
      .getFeedbacksByObjectiveStats(courseId, objectiveId, {
        ...params,
        classroomId: this.classroomId,
      })
      .pipe(
        map((e: any) => {
          e.forEach((item: any) => {
            item.completePrompt = item.prompt;
            item.prompt = this.adjustText(item.prompt);
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.feedbacks$.next(response);
        },
      });
  }
  adjustText(text: string): string {
    if (text.length > 20) {
      text = text.substring(0, 45) + "...";
    }
    return text;
  }
}
